<template>
  <input :placeholder=placeholder :type=type v-model="text" />
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'DebouncedSearch',
    props: {
      value: {required: true,},
      timeout: {default: 1000,},
      type: {default: 'search'},
      suggestions: {required: false, default: ()=>[], type: Array},
    },
    data () {return {
      text: this.value,
      debounced: _.debounce(() => {
        this.$emit('input', this.text);
      }, this.timeout),
    }},
    computed: {
      placeholder () {
        if (this.type === 'search') {
          return this.$t('search_for');
        }
        return '';
      },
    },
    watch: {
      value () {
        this.text = this.value;
      },
      text () {
        if (this.text != this.value) {
          if (this.suggestions.includes(this.text)) {
            //immediate change
            this.$emit('input', this.text);
          } else {
            this.debounced();
          }
        }
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/helpers/components/interact/DebouncedSearch.vue